//  findUI: data-ui
//   or  findBehavior: data-behavior
//   changed to findByRole: data-role
//   see github.com/remcoder/dataroles.js

import {
  flatten
} from './functions'

const getRoleSelector = role => `[data-role~="${role}"]`

const Roles = {
  findByRole(role, descendents) {
    let selector = getRoleSelector(role)

    if (descendents) {
      selector += ` ${descendents}`
    }

    // convert NodeList to array
    // let nl = Array.prototype.slice.call(this.querySelectorAll(selector));
    let nl = [...this.querySelectorAll(selector)]
    if (this.hasRole(role)) {
      nl = [this].concat(nl)
    }
    return flatten(nl)
  },

  // below additions inspired by github.com/remcoder/dataroles.js

  hasRole(role) {
    if (this.dataset && this.dataset.role) {
      if (this.dataset.role === role) {
        return true
      }
      return this.dataset.role.split(' ').contains(role)
    }

    return false
  },

  // used?
  getOrSetRole(value) {
    if (arguments.length > 0) {
      return this.set('data-role', value)
    }
    return this.get('data-role')
  }
}

// dom traversal
// Not as useful as I thought they'd be

const methods = [
  'closest',
  'getChildren',
  'getElements',
  "getParent",
  "getParents",

  // not implemented
  // 'match',
  // 'getNext',
  // 'getAllNext',
  // 'getPrevious',
  // 'getAllPrevious'
]

methods.forEach(method => {
  const key = `${method}ByRole`
  const d = {}

  // d[key] = (role) => {
  //     let selector = getRoleSelector(role);
  //     return this[method](selector);
  // }

  d[key] = function(role) {
    const selector = getRoleSelector(role)
    // console.log("method:", method);
    // console.log("selector:", selector);
    return this[method](selector)
  }

  Element.implement(d)
})

Element.implement(Roles)
Document.implement(Roles)

if (!window.ActiveXObject && 'ActiveXObject' in window) {
  HTMLDocument.implement(Roles)
  document.implement(Roles)
}

// wrap url
// duplicate of code in ui.js

// eslint-disable-next-line no-extra-semi
;
[...document.querySelectorAll('[data-wrap-url]')].forEach(p => {
  const x = document.createElement('a')

  x.href = p.dataset.wrapUrl

  x.setAttribute('class', 'anchor-wrapper')
  x.wraps(p)
})